<script>
	let className = $$props.class ? " " + $$props.class : "";
</script>

<div class="form-group form-row{className}"><slot></slot></div>
